import FocusTrap from 'focus-trap-react';
import { useCallback, useState } from 'react';
import { useOTSTranslation } from '@/i18n/useOTSTranslation';
import { Spinner } from '@/components/Spinner';
import { getTypeformId } from '@/config/getPortalConfig';

// Typeform feedback popup. Backdrop + centered card + custom "X" close
// button rendered with two rotated ::before/::after pseudo-elements.

const popupClass = 'fixed inset-0 z-[12] h-screen w-screen';

const backgroundClass = 'absolute inset-0 bg-black/50';

const popupBoxClass = [
  'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2',
  'w-[455px] h-[418px] flex items-center justify-center',
  'max-md:w-[calc(100%-20px)]',
  '[&_iframe]:w-full [&_iframe]:h-full',
].join(' ');

const closeClass = [
  'absolute -right-[30px] -top-[30px] w-3 h-3',
  'bg-transparent border-0 outline-none',
  'max-md:right-0',
  'hover:opacity-50 focus:opacity-50',
  'before:content-[""] before:absolute before:top-0 before:left-[5px] before:h-[13px] before:w-[3px] before:bg-white before:rotate-45',
  'after:content-[""] after:absolute after:top-0 after:left-[5px] after:h-[13px] after:w-[3px] after:bg-white after:-rotate-45',
].join(' ');

export const PopupFeedback = ({
  togglePopup,
  resort,
  id,
}: {
  togglePopup: () => void;
  resort: string;
  id: string;
}) => {
  const { t } = useOTSTranslation('common');
  const [isLoading, toggleIsLoading] = useState<boolean>(false);
  const path = 'https://form.typeform.com/to/';

  const setIsLoad = useCallback(() => {
    toggleIsLoading(true);
  }, []);

  const url = `${path}${getTypeformId()}?typeform-medium=embed-snippet#resort=${encodeURIComponent(
    resort,
  )}&id=${encodeURIComponent(id)}`;

  return (
    <FocusTrap>
      <div className={popupClass}>
        <div
          role="presentation"
          aria-hidden="true"
          tabIndex={-1}
          className={backgroundClass}
          onClick={togglePopup}
        />
        <div className={popupBoxClass}>
          {!isLoading && <Spinner color="#FFFFFF" />}
          <iframe
            title={t('resort.skiReport.provideFeedback')}
            src={url}
            onLoad={setIsLoad}
            className={!isLoading ? 'hidden' : ''}
          />
          <button
            type="button"
            aria-label={t('common.close')}
            className={closeClass}
            onClick={togglePopup}
          />
        </div>
      </div>
    </FocusTrap>
  );
};
